<script setup lang="ts">
const { t } = useI18n()
const prizeMoney = usePrizeMoney()
const image = import.meta.glob('~/assets/prizes/2025/prize-wide.png', { eager: true, import: 'default' })
const image_bigger = import.meta.glob('~/assets/prizes/2025/prize-wide-bigger.png', { eager: true, import: 'default' })
</script>

<template>
  <div class="min-h-30 overflow-hidden rd-md sm:rd-xl">
    <div class="relative bg-black">
      <div class="relative z-10 flex items-center justify-center">
        <div class="relative mx-auto py3 md:py6">
          <div class="relative text-center">
            <h2 class="text-lg text-white fw700 leading-tight tracking-tight uppercase md:text-4xl">
              {{ t('prize.your_order_could_be_winning') }}
            </h2>
            <h3 class="text-sm text-white/90 fw600 md:text-2xl">
              {{ t('prize.win_up_to', [prizeMoney]) }}
            </h3>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-slate-100 p1 hidden md:block">
      <NuxtImg
        :src="image['/assets/prizes/2025/prize-wide.png'] as string"
        class="w-full"
        width="664"
        height="116"
        fetchpriority="low"
        loading="lazy"
        alt="prizes"
      />
    </div>
    <div class="bg-slate-100 p1 md:hidden">
      <NuxtImg
        :src="image_bigger['/assets/prizes/2025/prize-wide-bigger.png'] as string"
        class="w-full"
        width="664"
        height="116"
        fetchpriority="low"
        loading="lazy"
        alt="prizes"
      />
    </div>
  </div>
</template>
